export interface IPlaceChangeImportParams {
  locationId: string
  holidays: { name: string; date: string }[]
  year: number
  country: string
  state?: string
  locale: string
}

export const placeChangeImportEvent = (params: IPlaceChangeImportParams) => ({
  eventType: 'LOCATION_HOLIDAYS_IMPORTED',
  eventGroup: 'LOCATION',
  ...params,
  recurring: true,
  holidayLib: 'DATE_HOLIDAYS',
  // The old place's imports go, so two countries' holidays don't mix.
  replaceImported: true,
})
